/* eslint-disable class-methods-use-this */
import { ICompanyInfo, OrderType } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

import { IGetCompanyResponseDTO } from './interfaces';

class SwipeRxWmsCompany extends SwipeRxWmsApi {
  constructor() {
    super(SwipeRxAPIResources.COMPANY);
  }

  async getUserCompanyInfo(
    queries: Record<string, number>,
  ): Promise<IGetCompanyResponseDTO> {
    try {
      const result = await this.get(`${this.apiResource}`, queries);

      if (!result.data) throw new Error('[FEError] Data not found');
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async updateCompanyInfo(
    payload: Partial<ICompanyInfo>,
  ): Promise<IGetCompanyResponseDTO> {
    try {
      const result = await this.patch(`${this.apiResource}`, payload);

      if (!result.data) throw new Error('[FEError] Update Failed');
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async uploadApjSignature(apjType: OrderType, formData: FormData) {
    try {
      const result = await this.post(
        `${this.apiResource}/${apjType}/upload/apj-sign`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async uploadApjStampedSignature(apjType: OrderType, formData: FormData) {
    try {
      const result = await this.post(
        `${this.apiResource}/${apjType}/upload/apj-stamped-sign`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }
}

export const swipeRxWmsAPICompany = new SwipeRxWmsCompany();
